<template>
    <div class="doc-area">
        <div class="doc-container scrollbar">
            <div class="doc-list">
                <doc
                    v-for="(doc, index) in docList"
                    :key="index"
                    :img="doc.url"
                    :time="doc.time"
                    :class="['doc-item', { active: index === activeIndex }]"
                    @click.native="handleClick(index, doc)"
                ></doc>
            </div>
        </div>
    </div>
</template>

<script>
import Doc from './Doc.vue';
export default {
    name: 'DocList',
    components: { Doc },
    props: {
        docList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {
        handleClick(index, item) {
            this.activeIndex = index;
            this.$emit('click', item);
        }
    }
};
</script>

<style lang="scss" scoped>
.doc-area {
    width: 148px;
    height: 100%;
    position: relative;
    background-color: rgba($color: #080808, $alpha: 0.5);
}
.doc {
    &-container {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    &-list {
        padding: 17px;
    }
    &-item {
        cursor: pointer;
        border: 1px solid transparent;
        & + & {
            margin-top: 17px;
        }
        &.active {
            border-color: rgba($color: #ec4444, $alpha: 0.63);
        }
        &:hover {
            border-color: #ec4444;
        }
    }
}
</style>
